import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Presentations
export const createPresentation = async (data) => {
  const response = await api.post('/presentations', data);
  return response.data;
};

export const getPresentation = async (id) => {
  const response = await api.get(`/presentations/${id}`);
  return response.data;
};

export const updatePresentation = async (id, data) => {
  const response = await api.put(`/presentations/${id}`, data);
  return response.data;
};

export const getUserPresentations = async (userId) => {
  const response = await api.get(`/users/${userId}/presentations`);
  return response.data;
};

export const deletePresentation = async (id) => {
  const response = await api.delete(`/presentations/${id}`);
  return response.data;
};

// Slides
export const updateSlide = async (id, data) => {
  const response = await api.put(`/slides/${id}`, data);
  return response.data;
};

// Sessions
export const createSession = async (presentationId) => {
  const response = await api.post('/sessions', { presentation_id: presentationId });
  return response.data;
};

export const getSession = async (sessionId) => {
  const response = await api.get(`/sessions/${sessionId}`);
  return response.data;
};

export const updateSession = async (sessionId, data) => {
  const response = await api.put(`/sessions/${sessionId}`, data);
  return response.data;
};

// AI Depth Generation
export const getAvailableModels = async () => {
  const response = await api.get('/depth/models');
  return response.data;
};

export const generateDepthNotes = async (slideText, model) => {
  const response = await api.post('/depth/generate', {
    slide_text: slideText,
    model: model
  });
  return response.data;
};

export default api;
